import React, { useEffect } from "react";
import ModalContainer from "../../components/ModalContainer.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import DataList from "../../components/DataList.jsx";

const UserDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const userRows = [
    {
      field: "__str__",
      text: "نام کامل",
    },
    {
      field: "phone_number",
      text: "شماره تلفن",
    },
    {
      field: "email",
      text: "پست الکترونیک",
    },
    {
      field: "province",
      text: "استان",
    },
    {
      field: "city",
      text: "شهر",
    },

    {
      field: "address",
      text: "آدرس",
    },
  ];

  useEffect(() => {
    if (!location.state) {
      return navigate(-1);
    }
  }, []);

  return (
    <ModalContainer
      alwaysOpen={true}
      fullscreen={false}
      title={`"${location.state?.code}"`}
    >
      <DataList listData={location.state?.customer} listRowsTitles={userRows} />
    </ModalContainer>
  );
};

export default UserDetails;
